import * as Highcharts from 'highcharts';
import * as jQuery from 'jquery';

import { AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';

import { ColorPalette } from '../../../../analytics-core/interfaces/partner.interface';
import { AnalyticsDataModel } from '../../../../analytics/models/analytics.datamodel';

@Component({
	selector: 'app-ctv-network-donut',
	styleUrls: ['./ctv-network-donut.component.css'],
	templateUrl: './ctv-network-donut.component.html'
})
export class CtvNetworkDonutComponent implements OnInit, AfterViewInit {
	@ViewChild('chartElement', { static: true }) chartElement: ElementRef;
	public chartObj: any;
	@Input() completionPercentage: number;
	@Input() networkUrl: string;
	@Input() events: any;
	@Input() smallInnerSize: any;
	@Input() innerSize: any;
	@Input() noDataColor: any;
	private renderedImage;
	private colorPalette: ColorPalette;

	constructor(protected analyticsDataModel: AnalyticsDataModel) {}
	@HostListener('window:resize', ['$event'])
	onResize(event: any): void {
		setTimeout(() => {
			this.reDrawImage();
		}, 1000);
	}

	ngOnInit(): void {
		this.completionPercentage = Number(this.completionPercentage);
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
	}

	ngAfterViewInit(): void {
		Highcharts.setOptions({
			lang: {
				thousandsSep: ','
			}
		});
		this.chartObj = Highcharts.chart({
			chart: {
				backgroundColor: 'transparent',
				events: this.events
					? this.smallInnerSize
						? {
								// tslint:disable-next-line: object-literal-shorthand
								load: function (): void {
									const graph = this.series[0].data[1]['graphic'];
									setTimeout(() => {
										const prevRadius = graph.r;
										const prevInnerRadius = graph.innerR;
										graph.attr({
											innerR: prevInnerRadius + 1.5,
											r: prevRadius - 0.5
										});
									}, 700);
								}
						  }
						: {
								// tslint:disable-next-line: object-literal-shorthand
								load: function (): void {
									const graph = this.series[0].data[1]['graphic'];
									setTimeout(() => {
										const prevRadius = graph.r;
										const prevInnerRadius = graph.innerR;
										graph.attr({
											innerR: prevInnerRadius + 3.5,
											r: prevRadius - 0.5
										});
									}, 700);
								}
						  }
					: null,
				renderTo: this.chartElement.nativeElement,
				type: 'pie'
			},
			credits: {
				enabled: false
			},
			legend: {
				align: 'center',
				enabled: false,
				layout: 'horizontal',
				verticalAlign: 'top',
				x: -15
			},
			plotOptions: {
				pie: {
					allowPointSelect: false,
					borderColor: null,
					borderWidth: 0,
					dataLabels: {
						enabled: false,
						format: '<b>{point.name}</b>: {point.percentage:.1f} %'
					},
					innerSize: this.innerSize ? this.innerSize : '85%',
					showInLegend: false,
					startAngle: 90
				},
				series: {
					states: {
						hover: {
							enabled: false
						},
						inactive: {
							opacity: 1
						}
					}
				}
			},
			series: [
				{
					data: [
						{
							color: this.colorPalette.primaryColor,
							name: 'Completion Rate',
							y: this.completionPercentage
						},
						{
							color: this.noDataColor ? this.noDataColor : '#D2D5D6',
							name: 'completions',
							y: 100 - this.completionPercentage
						}
					],
					name: 'CTV Featured Networks Completion Rate',
					type: 'pie'
				}
			],
			subtitle: {
				text: null
			},
			title: {
				text: null
			},
			tooltip: {
				enabled: false,
				// tslint:disable-next-line: object-literal-shorthand
				formatter: function (): string {
					// tslint:disable-next-line: prefer-template
					return this.series.name + ' : <b>' + this.y + (this.series.name === 'Cost' ? '% </b>' : '</b>');
				},
				useHTML: true
			}
		});
		jQuery(this.chartObj.container).css('margin', '0 auto');
		this.drawImage();
	}
	drawImage(): void {
		((chart) => {
			const width = chart.chartWidth;
			const xPos = (width - 75 / 2 - 30) / 2.16;
			this.renderedImage = chart.renderer.image(this.networkUrl, xPos, 60, 75, 75).add();
		})(this.chartObj);
	}

	reDrawImage(): void {
		if (this.renderedImage) {
			const width = this.chartObj.chartWidth;
			const xPos = (width - 75 / 2 - 30) / 2.16;
			this.renderedImage.attr('x', xPos);
		}
	}
}
